

let privateParams = {
    AppMobileWeb: 'app',
    bonusId: '',
    bonusRuleGroupId: null,
    domainName: '',
    successUrl: '',
    e2Backbox: '',
    ActiveMethods: '',
    firstName: '',
    depositingWallet: '',//首选账户
    paymentBalance: 0,//余额
    balance:0, //錢包餘額


    siteId: "",
    device: '',
    platformType: '',
    languageType: '',
    ApiDomain: "",

    getSeonSession: async ()=>{return undefined},
    BackClick: () => { console.log('返回') },
    BackMyPromo: () => { console.log('返回优惠页面') }, //follow M2 App method名稱，但正確行為應是回到promotion list

    LivechatClick: () => { console.log('客服') },
    openService: () => {},

    goRecord: () => {},

    goAddBankInfo: () => {},


    reloadBalance: () => {},

    withdrawalHeader: () => {},

    webPiwikEvent: () => {},
    PiwikEventDataHandle: () => {},
    webPiwikUrl: () => {},
    appPiwikEvent: () => {},
    appPiwikUrl: () => {},


    ApiGet: () => {},
    ApiPost: () => {},
    ApiPatch: () => {},
    goDeposit: () => {},
    goVerifyContact: () => {},
    goFinishKYCInfo: () => {},
    goFinishMemberInfo: () => {},
    modalTip: {
        info: () => {},
        confirm: () => {},
        close: () => {},
    },
    toastTip: {
        loading: () => {},
        success: () => {},
        error: () => {},
        hide: () => {}
    },
    toggleHideWithdrawHeader: () => {},// app mobile 提款成功后， 用于隐藏上方的header
    headerBannerHide: false, // Insufficient Balance 存款隱藏header
    BackEventPage: ()=>{ console.log('返回小遊戲頁面') }
};


export function setFEWalletParam(key, val) {
    privateParams[key] = val;
}

export function setFEWalletParams(data) {
    for (let key in data) {
        privateParams[key] = data[key];
    }
}

export function getFEWalletParams() {
    return privateParams;
}
